/*************************************************/
/* Vue                                           */
/*************************************************/

import { createApp, h } from 'vue';
import { createRouter, createWebHistory } from "vue-router";
import Cases from './vue/cases.vue';


const casesAppSelector = "#casesApp";
if (document.querySelector(casesAppSelector) != null) {
    const rawCasesNodeIds = document.querySelector(casesAppSelector).dataset.casesNodeIds;
    const pageSize = document.querySelector(casesAppSelector).dataset.pagesize;
    const showFilters = document.querySelector(casesAppSelector).dataset.showFilters;
    const preselectedIndustry = document.querySelector(casesAppSelector).dataset.preselectedIndustry?.trim()
        ? document.querySelector(casesAppSelector).dataset.preselectedIndustry.split(',').filter(x => x.trim() !== '')
        : [];

    const preselectedCompetence = document.querySelector(casesAppSelector).dataset.preselectedCompetence?.trim()
        ? document.querySelector(casesAppSelector).dataset.preselectedCompetence.split(',').filter(x => x.trim() !== '')
        : [];

    const preselectedProduct = document.querySelector(casesAppSelector).dataset.preselectedProduct?.trim()
        ? document.querySelector(casesAppSelector).dataset.preselectedProduct.split(',').filter(x => x.trim() !== '')
        : [];

    const casesNodeIds = rawCasesNodeIds
        .split(',')
        .map(id => parseInt(id, 10))
        .filter(id => !isNaN(id));

    const router = createRouter({
        history: createWebHistory(),
        routes: [{ path: window.location.pathname, component: Cases }]
    });

    const seedData = { casesNodeIds: casesNodeIds, pageSize: pageSize, showFilters: showFilters, preselectedIndustry: preselectedIndustry, preselectedCompetence: preselectedCompetence, preselectedProduct: preselectedProduct };

    const casesApp = createApp({
        data() { return seedData },
        render: () => h(Cases)
    }, seedData);


    casesApp.use(router);
    router.isReady().then(() => casesApp.mount(casesAppSelector));
}